// useToast.ts
import { CoherenceNotificationType } from '@coherence-design-system/controls';
import { useState, useRef } from 'react'; 
import { useNotifications, NotificationSeverity } from '../contexts/NotificationContext';

const toastTypeToSeverity: Record<string, NotificationSeverity> = {
  [CoherenceNotificationType.SUCCESS]: NotificationSeverity.Success,
  [CoherenceNotificationType.ERROR]: NotificationSeverity.Error,
  [CoherenceNotificationType.WARNING]: NotificationSeverity.Warning,
  [CoherenceNotificationType.PENDING]: NotificationSeverity.Info,
};

export const useToast = () => {
  const [showToast, setShowToast] = useState(false);
  const [toastTitle, setToastTitle] = useState('');
  const [toastMessage, setToastMessage] = useState('');
  const [toastType, setToastType] = useState<CoherenceNotificationType>(CoherenceNotificationType.SUCCESS);
  const dismissTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const { addNotification } = useNotifications();
  
  const showToastMessage = (
    title: string,
    message: string,
    type: CoherenceNotificationType,
    timer?: number
  ) => {
    // Clear any pending auto-dismiss timer from a previous toast
    if (dismissTimerRef.current) {
      clearTimeout(dismissTimerRef.current);
      dismissTimerRef.current = null;
    }

    setShowToast(true);
    setToastTitle(title);
    setToastMessage(message);
    setToastType(type);

    // Push to notification panel
    addNotification({
      title,
      message,
      severity: toastTypeToSeverity[type] || NotificationSeverity.Info,
    });

   if(type!=CoherenceNotificationType.PENDING){
    const defaultTimePerChar = 100;
    const minTime = 3000;
    const maxTime = 15000;
    const calculatedTime = Math.min(
      Math.max(message.length * defaultTimePerChar, minTime),
      maxTime
    );
   
    dismissTimerRef.current = setTimeout(() => setShowToast(false), timer ?? calculatedTime);
  }

  };

  return { showToast, toastTitle, toastMessage, toastType, showToastMessage };
};
